"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var t=function(r){try{return{error:!1,value:r()}}catch(e){return{error:!0,value:e}}};exports.perform=t;
